import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormControl} from '@angular/forms';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {WorkrequestHydViewmodel} from '../workrequest-hyd-viewmodel';
import {HydVehicleBackflowDetails, WorkrequestHydDetails} from '../workrequest-hyd-details';
import {SelectItem} from 'primeng/primeng';
import {AddressService} from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-hyd',
  templateUrl: './workrequest-hyd.component.html',
  styleUrls: ['./workrequest-hyd.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WorkrequestHydComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestHydViewmodel;

  applicationFeerequiredControl: FormControl;
  numberRegEx = /^[0-9]*$/;
  pricingZone: string = SERVICE_PROVIDER.CWW;

  constructor(private loginService: LoginService, private addressService: AddressService, private feeService: FeeService) {
    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestHydViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestHydDetails();
    }

    this.applicationFeerequiredControl = new FormControl({value: true, disabled: true});

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    this.loadFees();
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  };

  public calculateTotalAmount(): void {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.applicationFeeAmount;
  }

  get hydVehicleBackflowDetails(): HydVehicleBackflowDetails[] {
    return this.workRequestViewModel.workrequestDetails.hydVehicleBackflowDetailsList;
  }

  loadFees(): void {
    this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), ok => {
        if (ok) {
          this.workRequestViewModel.applicantFeeAmount = this.feeService.getHydrantApplicationFeeAmount(this.pricingZone);
          this.calculateTotalAmount();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  get applicationFeeAmount(): number {
    return this.workRequestViewModel.applicantFeeAmount;
  }

  get applicationFeerequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.applicationFeerequired;
  }

  set applicationFeerequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.applicationFeerequired = v;
  }

  get isTankRemovableOptions(): SelectItem [] {
    return [{label: 'Please select...', value: ''}, {label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}];
  }

  get rpzAirGapOptions(): SelectItem [] {
    return [{label: 'Please select...', value: ''}, {label: 'RPZ', value: 'RPZ'}, {label: 'AIR GAP', value: 'AIR GAP'}];
  }

  get civalWorksDomesticDrinkingWaterOptions(): SelectItem[] {
    return [{label: 'Please select...', value: ''}, {label: 'CIVIL WORKS', value: 'CIVIL WORKS'},
      {label: 'DOMESTIC DRINKING WATER', value: 'DOMESTIC DRINKING WATER'}];
  }

  displayErrorMessage(): string {
    this.workRequestViewModel.invalidSelectionError = '';
    this.applicationFeerequiredControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';
    let noData = true;

    for (let i = 0; i < this.workRequestViewModel.workrequestDetails.hydVehicleBackflowDetailsList.length; i++) {
      const hydVehicleBackflowDetails = this.workRequestViewModel.workrequestDetails.hydVehicleBackflowDetailsList[i];

      if (hydVehicleBackflowDetails.registerationNumber === '' && hydVehicleBackflowDetails.capacity === ''
        && (hydVehicleBackflowDetails.isTankRemovable === '' || hydVehicleBackflowDetails.isTankRemovable === 'Please select...')
        && (hydVehicleBackflowDetails.rpzAirGap === 'Please select...' || hydVehicleBackflowDetails.rpzAirGap === '')
        && (hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === 'Please select...'
          || hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === ''
        )) {
        continue;
      }
      noData = false;

      if (hydVehicleBackflowDetails.registerationNumber === '' || hydVehicleBackflowDetails.capacity === ''
        || (hydVehicleBackflowDetails.isTankRemovable === ''  || hydVehicleBackflowDetails.isTankRemovable === 'Please select...')
        || (hydVehicleBackflowDetails.rpzAirGap === 'Please select...' || hydVehicleBackflowDetails.rpzAirGap === '')
        || (hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === 'Please select...'
          || hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === ''
        )) {
        errorText = 'Please select enter valid data.';
        break;
      }

      const capacity: number = Number(hydVehicleBackflowDetails.capacity);
      if (capacity < 1 || capacity > 20000) {
        errorText = 'Please select enter valid value for capacity (between 1 and 20000).';
        break;
      }
    }

    if (noData) {
      errorText = 'Please enter detail for at least one vehicle and backflow.';
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.applicationFeerequiredControl.markAsUntouched();
    this.loadFees();
  }

  get getCssClass(): string {
    if (!this.isGuestUserLoggedIn()) {
      if (this.isReadOnly) {
        return 'form-control';
      }

      return 'no-border col-md-6';
    }

    return 'form-control';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/hyd-form/workrequest-hyd/workrequest-hyd.component.ts